<template>
  <!-- Footer -->
  <mdb-footer color="light-green lighten-4" class="font-medium pt-4 mt-4">
    <mdb-container class="text-left">
      <mdb-row>
        <mdb-col sm="6">
          <h5 class="title textoFooter">HESTIA - Eficiencia Energética</h5>
          <label class="textoFooter">&copy; 2020 Copyright: Braian Jullier y Juan José Sarasola</label>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </mdb-footer>
  <!-- Footer -->
</template>

<script>
  import { mdbFooter, mdbContainer, mdbRow, mdbCol, mdbIcon } from 'mdbvue';
  export default {
    name: 'Footer',
    components: {
      mdbFooter,
      mdbContainer,
      mdbRow,
      mdbCol
    },
    computed: {
        url: function() {
        return `./hestia.jpeg`;
        }
    }
  }
</script>
<style scoped>
.textoFooter{
    color: DARKSLATEGRAY;
}
</style>